import api, { withLoading } from '@/api/api';
import parseParams from "@/helpers/objectToQueryParams";

/**
 * Representa uma linha da análise de "Realizado versus Orçado" (R.X.O)
 *
 * @typedef {Object} RxoAnalise
 * @property {number} id - Identificador do projeto
 * @property {string} colaborador - Colaborador responsável
 * @property {string} bp - Business Plan
 * @property {string} versao_oficial - Versão oficial
 * @property {string} realizado - Valor realizado
 * @property {string} rxo - Valor de R.X.O
 * @property {string} justificativa - Justificativa da análise
 */

/**
 * ⚠️ Endpoint do módulo **Projects** (`Modules\Projects\ProjetoController@getProjectsByClientPending`,
 * rota `GET /v1/projetos/{empresaId}/analise`), consumido indiretamente pela tela de
 * Ativação de P&D (`templates/ativacaoped/rxo/rxo.ativacao.vue`). Vive aqui para que
 * a camada `src/api/ativacaoped` continue sendo a única porta de saída de API do módulo.
 */
const resource = {
  analise: (empresaId) => `v1/projetos/${empresaId}/analise`
};

const LOADING_KEY = 'ativacaoped-rxo';

/**
 * Lista os projetos em análise (R.X.O) da empresa.
 *
 * Backend pagina (`paginate` + `ProjetoResource::collection`) → o corpo é
 * `{ data, meta, links }` e é devolvido inteiro (comportamento legado da tela).
 *
 * @param {number|string} empresaId - ID da empresa
 * @param {Object|string} [params] - Parâmetros de consulta (objeto) ou query string já montada
 * @returns {Promise<PaginacaoLaravelResource<RxoAnalise>>} Lista paginada de projetos em análise
 */
export const getRxoAnalise = (empresaId, params = {}) => {
  // Aceita a query string crua montada pelo MasterDetail (page/per_page/sort/filters).
  const query = typeof params === "string" ? params : parseParams(params);
  let url = resource.analise(empresaId);

  if (query) {
    url = url.concat(`?${query}`);
  }

  return withLoading(LOADING_KEY, () =>
    api.get(url).then(({ data }) => data)
  );
};

export default {
  getRxoAnalise
};
